<template>
  <nav v-if="shouldShowPagination">
    <div
      class="pagination-container d-flex align-items-center"
      style="float: right"
    >
      <!-- Rows per page widget -->
      <div class="rows-per-page-widget mr-4">
        <label for="rowsPerPage" class="me-2">Rows per page:</label>
        <select
          id="rowsPerPage"
          v-model="rowsPerPage"
          @change="rowsPerPageChanged"
          class="form-select d-inline-block"
          style="width: auto;"
        >
          <option
            v-for="option in rowsPerPageOptions"
            :key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
      </div>

      <ul class="pagination justify-content-center">
        <li :class="{ disabled: pagination.currentPage === 1 }">
          <a
            :class="{ disabled: pagination.currentPage === 1 }"
            @click="pageClicked(pagination.currentPage - 1)"
          >
            <i class="left chevron icon">«</i>
          </a>
        </li>
        <li v-if="hasFirst" :class="{ active: isActive(1) }" class="page-item">
          <a class="page-link" @click="pageClicked(1)">1</a>
        </li>
        <li v-if="hasFirstEllipsis">
          <span class="pagination-ellipsis">&hellip;</span>
        </li>
        <li
          v-for="page in pages"
          :key="page"
          :class="{ active: isActive(page), disabled: page === '...' }"
          class="page-item"
        >
          <a class="page-link" @click="pageClicked(page)">{{ page }}</a>
        </li>
        <li v-if="hasLastEllipsis">
          <span class="pagination-ellipsis">&hellip;</span>
        </li>
        <li
          v-if="hasLast"
          :class="{ active: isActive(this.pagination.totalPages) }"
          class="page-item"
        >
          <a class="page-link" @click="pageClicked(pagination.totalPages)">
            {{ pagination.totalPages }}
          </a>
        </li>
        <li>
          <a
            :class="{
              disabled: pagination.currentPage === pagination.totalPages
            }"
            @click="pageClicked(pagination.currentPage + 1)"
          >
            <i class="right chevron icon">»</i>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      default: () => ({
        currentPage: 1,
        totalPages: 1,
        rowsPerPage: 10,
        count: 0
      })
    }
  },
  data() {
    return {
      rowsPerPage: this.pagination.rowsPerPage || 10, // Default rows per page
      rowsPerPageOptions: [10, 25, 50] // Options for rows per page
    };
  },
  computed: {
    pages() {
      return this.pagination.totalPages === undefined ? [] : this.pageLinks();
    },

    hasFirst() {
      return (
        this.pagination.currentPage >= 4 || this.pagination.totalPages < 10
      );
    },

    hasLast() {
      return (
        this.pagination.currentPage <= this.pagination.totalPages - 3 ||
        this.pagination.totalPages < 10
      );
    },

    hasFirstEllipsis() {
      return (
        this.pagination.currentPage >= 4 && this.pagination.totalPages >= 10
      );
    },

    hasLastEllipsis() {
      return (
        this.pagination.currentPage <= this.pagination.totalPages - 3 &&
        this.pagination.totalPages >= 10
      );
    },

    shouldShowPagination() {
      if (this.pagination.totalPages === undefined) {
        return false;
      }

      if (this.pagination.count === 0) {
        return false;
      }

      return this.pagination.totalPages > 1;
    }
  },
  methods: {
    isActive(page) {
      const currentPage = this.pagination.currentPage || 1;

      return currentPage === page;
    },
    pageClicked(page) {
      if (
        page === "..." ||
        page === this.pagination.currentPage ||
        page > this.pagination.totalPages ||
        page < 1
      ) {
        return;
      }
      this.$emit("pageChange", page);
    },
    rowsPerPageChanged() {
      this.$emit("rowsPerPageChange", this.rowsPerPage);
    },
    pageLinks() {
      const pages = [];

      let left = 2;
      let right = this.pagination.totalPages - 1;

      if (this.pagination.totalPages >= 10) {
        left = Math.max(1, this.pagination.currentPage - 2);
        right = Math.min(
          this.pagination.currentPage + 2,
          this.pagination.totalPages
        );
      }
      for (let i = left; i <= right; i++) {
        pages.push(i);
      }

      return pages;
    }
  }
};
</script>

<style scoped>
.rows-per-page-widget {
  margin-left: 1rem; /* Add space between pagination and rows per page */
}

.rows-per-page-widget select {
  width: auto; /* Ensures the select box doesn't stretch */
  height: 4.7vh;
  border: 1px solid #dee2e6;
}
</style>
